import React, {  useState, useEffect } from 'react';
import $ from 'jquery';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import SubscribeData from './SubscribeData';
export default function Subscribe(props)  {
    const stripe = useStripe();
    const elements = useElements();
 


    const submitAll = async (teamsAdd, teamsRemove) => {
      
        if (!stripe || !elements) {
           
            return;
        }
        props.showBusy(true);
        var data = { teamsAdd,teamsRemove}
        const resp = await fetch('api/billing/savesub', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        }
        );
        if (resp.status === 200) {
            try {
                //Switch to list of subscriptions and check each
                const { addedSubsList } = await resp.json();

                // const successSubs = [];
                let failedSubArr = [];

                for (let index = 0; index < addedSubsList.length; index++) {
                    let subscription = addedSubsList[index];
                    console.log(subscription);
                    let result = await confirmCardPayment(subscription);
                    console.log(result);
                    if (!result.success) {
                        failedSubArr = failedSubArr.concat(result.failedSubArr);
                        console.log(failedSubArr);
                        break;
                    }
                }

                console.log(failedSubArr.length);
                props.billingSubEnd(failedSubArr.length > 0 ? failedSubArr : null)


            } catch (e) {
                console.log(e);
            }
            props.showBusy(false); try {
                //Switch to list of subscriptions and check each
                const { addedSubsList } = await resp.json();

                // const successSubs = [];
                let failedSubArr = [];

                for (let index = 0; index < addedSubsList.length; index++) {
                    let subscription = addedSubsList[index];
                    console.log(subscription);
                    let result = await confirmCardPayment(subscription);
                    console.log(result);
                    if (!result.success) {
                        failedSubArr = failedSubArr.concat(result.failedSubArr);
                        console.log(failedSubArr);
                        break;
                    }
                }

                console.log(failedSubArr.length);
                props.billingSubEnd(failedSubArr.length > 0 ? failedSubArr : null)


            } catch (e) {
                console.log(e);
            }
            props.showBusy(false);
        }
        else if (resp.status === 400 || resp.status === 404) {
            console.log(resp);
            var respData = await resp.json()
            console.log(respData);
        }
        else {
            this.setState({ message: 'There was a problem, please try again later' });
            
        }
        
} 
    const confirmCardPayment = async (subscription) => {
        let returnObj = {
            success:true,
            failedSubArr:[]
        };
        console.log(subscription);
        let { latest_invoice } = subscription;

        let { payment_intent } = latest_invoice;

        if (payment_intent) {
            let { client_secret, status } = payment_intent;

            if (status === 'requires_action') {
                await stripe.confirmCardPayment(client_secret).then(function (result) {
                    console.log(result);
                    if (result.error) {
                        console.log(result.error);

                        returnObj.failedSubArr.push(subscription);
                        returnObj.failedSubArr.push(result.error);
                        returnObj.success = false;

                        // Display error message in your UI.
                        // The card was declined (i.e. insufficient funds, card has expired, etc)
                    } else {
                        console.log("Required action but succeeded");
                        // Show a success message to your customer
                    }

                });
            }
            else if (status === "requires_payment_method") {
                var data = {customer:subscription.customer, invoice:latest_invoice.id}
                const resp = await fetch('api/billing/retrysub', {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
                );
                if (resp.status === 200) {
                    var jdata = await resp.json();
                    console.log(jdata);
                    if (!jdata.success) {
                        returnObj.failedSubArr.push(subscription);
                        returnObj.failedSubArr.push("Unknown Error.");
                        returnObj.success = false;
                    }
                }
               
            }
        }
        return returnObj;
    }
    const retrySub = async (subId) => {

        if (!stripe || !elements) {

            return;
        }
        
        var data = { subscriptionId:subId }
        const resp = await fetch('api/billing/retrievesub', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        }
        );
        try {
            
            const { subscription } = await resp.json();
            console.log(subscription);
            // const successSubs = [];
            let failedSubArr = [];

            let result = await confirmCardPayment(subscription);
            console.log(result);
            if (!result.success) {
                failedSubArr = failedSubArr.concat(result.failedSubArr);
                console.log(failedSubArr);               
            }         
            props.billingSubEnd(failedSubArr.length > 0 ? failedSubArr : null)


        } catch (e) {
            console.log(e);
        }
    } 
        return (
            <div>         
                <SubscribeData {...props} submit={submitAll} retry={retrySub}/>
            </div>

        );
    
}


